import React, { Component } from 'react';
import i18n from '../../config/i18n';
import clearIcon from '../../styles/icons/clear.svg';
import searchIcon from '../../styles/icons/search.svg';

const buttonStyle = {
  border: '2px solid #DCE4EC',
  height: '45px',
};

class Search4Field extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      identification: '',
      dateOfBirth: '',
    };
  }


  onClickGetData = () => {
    const rawInputValue = Object.assign({}, this.state);
    const inputValue = {};
    Object.keys(rawInputValue).forEach((key) => {
      const val = rawInputValue[key];
      if (val) {
        inputValue[key] = { regexp: val };
      }
    });
    const filterValue = Object.keys(inputValue).length ? JSON.stringify({ where: inputValue }) : '';
    this.props.onClickSearch.call(this, filterValue);
  };

  onClickClearData = () => {
    this.setState({
      firstName: '',
      lastName: '',
      identification: '',
      dateOfBirth: '',
    });

    // Clear all input boxes
    this.firstName.value = '';
    this.lastName.value = '';
    this.identification.value = '';
    this.dateOfBirth.value = '';

    this.props.onClickClear.call(this);
  };

  onKeyUpHandler = (e) => {
    const newField = {};
    newField[e.target.name] = e.target.value.trim();
    this.setState(newField);
  };

  onKeyDownHandler = (e) => {
    // TODO(kwang): Should create a constant like KEYCODE_ENTER = 13 elsewhere.
    // hit enter should trigger search
    if (e.keyCode === 13) {
      this.onClickGetData();
    }
  };


  renderInputDiv(ref, placeholder) {
    return (
      <div className="col-sm-3">
        <input
          name={ref}
          className="form-control searchBar"
          type="text"
          placeholder={placeholder}
          ref={(input) => { this[ref] = input; }}
          onKeyUp={this.onKeyUpHandler}
          onKeyDown={this.onKeyDownHandler}
        />
      </div>
    );
  }

  renderInputCollections() {
    return (
      <div>
        {this.renderInputDiv('firstName', i18n.t('firstName'))}
        {this.renderInputDiv('lastName', i18n.t('lastName'))}
        {this.renderInputDiv('identification', i18n.t('id'))}
        {this.renderInputDiv('dateOfBirth', i18n.t('dob_format'))}
      </div>
    );
  }

  render() {
    const inputCollections = this.renderInputCollections();
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        {inputCollections}
        <div>
          <div className="col-sm-12" style={{ textAlign: 'right', marginTop: 10, marginBottom: 10 }}>
            <button
              style={buttonStyle}
              type="button"
              className="btn btn-primary searchButton"
              onClick={this.onClickGetData}
            >
              <img
                style={{ height: '24px', width: '24px' }}
                className="svg-icon"
                alt={i18n.t('search')}
                src={searchIcon}
              />
            </button>
            <button
              style={buttonStyle}
              type="button"
              className="btn btn-default clearButton"
              onClick={this.onClickClearData}
            >
              <img
                style={{ height: '20px', width: '20px' }}
                className="svg-icon"
                alt={i18n.t('clear')}
                src={clearIcon}
              />
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default Search4Field;



// WEBPACK FOOTER //
// ./src/components/shared/Search4Field.js